import { h } from 'preact';
import PropTypes from 'prop-types';

import { IconClose } from '../../1-foundation/icons/icons';
import OverlayWrapper from '../overlay-wrapper/overlay-wrapper';

const DEFAULT_IS_ACTIVE = false;

const SkyItModalWithPanel = ({ onCancel, isActive = DEFAULT_IS_ACTIVE, children }) => {
  return (
    <OverlayWrapper showOverlay={isActive}>
      <div className="c-modal c-modal--with-panel" data-state="active">
        <div className="c-modal__container-ext">
          <div className="c-modal__container-int">
            <div className="c-modal__toolbar">
              <button type="button" className="c-modal__tool c-modal__tool--close" onClick={onCancel}>
                <IconClose modifiers={['navigation', 'c-medium-light-2', 'small', 'close']} />
              </button>
            </div>
            {children}
          </div>
        </div>
      </div>
    </OverlayWrapper>
  );
};

SkyItModalWithPanel.propTypes = {
  children: PropTypes.any,
  isActive: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
};

export default SkyItModalWithPanel;
